import { ServicioPropiedadDetailDto } from "../servicio-propiedad/servicioPropiedadDetailDto.model";

export class DetalleServicioPropiedadGroupByServicioPropiedadResponse {

  public servicios: ServicioPropiedadDetailDto[] = []
}
